import React from "react";
// import { faqService } from "./model/service";
import EFaqs from "./view/_faqs";
export default function E_Faqs({ searchFAQData, keyWord }) {
  return (
        <EFaqs
          // getFaqData={faqService.getAuthFaq}
          searchFAQData={searchFAQData}
          keyWord={keyWord}
        />

  );
}
